import Vue from 'vue';
import Vuelidate from 'vuelidate';
import VueCompositionAPI from '@vue/composition-api';
import { store } from '@/app/shared/stores/store';
import App from './app/app.vue';
import router from './app/app-routes';

Vue.use(Vuelidate);
Vue.use(VueCompositionAPI);

Vue.config.productionTip = false;

Vue.use(require('vue-moment'));

const vue = new Vue({
  router,
  store,
  render: h => h(App),
});

vue.$mount('#app');
